import TornFrame from "./TornFrame";
import { useLightbox } from "./LightboxContext";

const CARD_ROTATIONS = [-2.5, 2, -1.5, 2.5, -2];

const Poster = ({ role, variant }) => {
  const { open } = useLightbox();
  const size = variant === "officer" ? 420 : 300;

  return (
    <TornFrame
      id={`${role.id}-poster`}
      rotate={variant === "officer" ? 1.5 : -2}
      pointsPerEdge={20}
      jitter={2}
      className="board-poster"
      style={{ flex: `0 1 ${size}px`, minWidth: "200px" }}
      onClick={role.posterImage ? () => open(role.posterImage, role.title, { large: false }) : undefined}
    >
      {role.posterImage ? (
        <img src={role.posterImage} alt={role.title} className="board-poster-img" />
      ) : (
        <div className="board-placeholder-art" aria-hidden="true">
          {role.title[0]}
        </div>
      )}
    </TornFrame>
  );
};

const MemberCards = ({ role }) => {
  const { open } = useLightbox();

  return (
    <div className="board-member-row">
      {role.members.map((member, i) => (
        <div className="board-member-card" key={`${role.id}-member-${i}`}>
          <TornFrame
            id={`${role.id}-member-${i}`}
            rotate={CARD_ROTATIONS[i % CARD_ROTATIONS.length]}
            pointsPerEdge={14}
            jitter={2.5}
            padding="6px"
            className="board-member-photo"
            onClick={member.photo ? () => open(member.photo, member.name || role.title, { large: true }) : undefined}
          >
            {member.photo ? (
              <img src={member.photo} alt={member.name || role.title} className="board-member-img" />
            ) : (
              <div className="board-placeholder-art board-placeholder-art--small" aria-hidden="true">
                {role.title[0]}
              </div>
            )}
          </TornFrame>
          <span className={`board-member-name${member.name ? "" : " board-member-name--placeholder"}`}>
            {member.name || "Member Name"}
          </span>
        </div>
      ))}
    </div>
  );
};

const DescriptionBox = ({ role, variant }) => (
  <TornFrame
    id={`${role.id}-description`}
    rotate={variant === "officer" ? -1.5 : 1}
    pointsPerEdge={16}
    jitter={2.5}
    padding="18px 20px"
    background={variant === "officer" ? "#12201f" : "#efe7d3"}
    className="board-description"
    style={{ maxWidth: "320px" }}
  >
    <p className={`board-description-text board-description-text--${variant}`}>{role.description}</p>
  </TornFrame>
);

const BELT_REPEATS = 6;

const RoleBlock = ({ role, variant, reverse }) => {
  const titleText = role.title;
  const beltSequence = Array(BELT_REPEATS).fill(titleText).join(" • ");

  return (
    <article className={`board-role-block board-role-block--${variant}`}>
      <div
        className="board-role-title-wrap"
        style={{ textAlign: reverse ? "right" : "left" }}
      >
        <div className="board-role-title-outline-clip" aria-hidden="true">
          <div
            className={`board-role-title-outline-track${reverse ? " board-role-title-outline-track--reverse" : ""}`}
          >
            <span className="board-role-title-outline-seq">{beltSequence}&nbsp;</span>
            <span className="board-role-title-outline-seq">{beltSequence}&nbsp;</span>
          </div>
        </div>
        <h3 className="board-role-title">{titleText}</h3>
      </div>

      {variant === "exec" ? (
        <div className="board-role-content" style={{ flexDirection: reverse ? "row-reverse" : "row" }}>
          <Poster role={role} variant={variant} />
          <MemberCards role={role} />
          <DescriptionBox role={role} variant={variant} />
        </div>
      ) : (
        <div
          className="board-role-content board-role-content--officer"
          style={{ flexDirection: reverse ? "row-reverse" : "row" }}
        >
          <Poster role={role} variant={variant} />
          <div className="board-role-side-column">
            <MemberCards role={role} />
            <DescriptionBox role={role} variant={variant} />
          </div>
        </div>
      )}
    </article>
  );
};

export default RoleBlock;
